module.exports = __webpack_public_path__ + "static/img/game-img-xzgt.20501a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/game-img-xzgt.png
// module id = mbyM
// module chunks = 0